/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementParameterDoubleDto
 */
export interface TrackItMeasurementParameterDoubleDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterDoubleDto
     */
    $type?: TrackItMeasurementParameterDoubleDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterDoubleDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterDoubleDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterDoubleDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterDoubleDtoTypeEnum = typeof TrackItMeasurementParameterDoubleDtoTypeEnum[keyof typeof TrackItMeasurementParameterDoubleDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterDoubleDto interface.
 */
export function instanceOfTrackItMeasurementParameterDoubleDto(value?: unknown): value is TrackItMeasurementParameterDoubleDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterDoubleDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterDoubleDtoFromJSON(json: any): TrackItMeasurementParameterDoubleDto {
    return TrackItMeasurementParameterDoubleDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterDoubleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterDoubleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'index': json['index'] == null ? undefined : json['index'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterDoubleDtoToJSON(value?: TrackItMeasurementParameterDoubleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'index': value['index'],
        'unit': value['unit'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

